import Vue from 'vue';

/**
 * Simple directive to identify elements that will trigger popups on
 * click or hover.
 *
 */
const directive = {
    /* eslint-disable func-names */
    /* eslint-disable object-shorthand */
    bind: function (el, {value = 'trigger'}) {
        el.setAttribute('data-popper-trigger', value);
    },
};

Vue.directive('popper-trigger', directive);
